import type { ImgHTMLAttributes } from 'react';

import onboardingStep1Webp from './OnboardingStep1.webp';

export const OnboardingStep1 = (props: ImgHTMLAttributes<HTMLImageElement>) => (
	<img
		src={onboardingStep1Webp}
		alt="Blocked desktop image"
		width={1242}
		height={1200}
		{...props}
	/>
);
